import React from 'react'

export function Header(){
	return (
		<p className="b">
			32<sup>nd</sup> Legislative District Democratic Organization
		</p>
	)
}
